export const APP_BRAND = {
  appName: 'Sunbrick ERP',
  companyName: 'Sunbrick America',
  logoPath: '/sunbrick-logo.png',
  logoAlt: 'Sunbrick America',
  authTitle: 'Sunbrick ERP',
  authSubtitleEs: 'Accede al panel administrativo.',
  authSubtitleEn: 'Access the admin console.',
} as const;
